export default "__VITE_ASSET__Ba_VU3fF__"